export const auth = {
errors: {
  deleteAccountFailed: "No se eliminó su cuenta. Inténtelo de nuevo.",
  workspacePreparing: "Su espacio de trabajo todavía se está preparando. Espere un momento e inténtelo de nuevo.",
  signInAgain: "Vuelva a iniciar sesión para continuar.",
  callbackCancelled: "El inicio de sesión se canceló antes de terminar. Inténtelo de nuevo cuando quiera.",
  signInNotFinished: "No se completó el inicio de sesión. Inténtelo de nuevo.",
  signupUnavailable: "No podemos crear cuentas en este momento. Inténtelo más tarde.",
  signupClosed: "Por ahora, las cuentas nuevas son solo por invitación. Use el enlace de su correo de invitación o inicie sesión con la cuenta que ya tiene.",
  linkExpired: "Este enlace ha caducado o ya se usó. Pida uno nuevo.",
  emailInvalid: "Introduzca una dirección de correo válida.",
  passwordTooCommon: "Esa contraseña es demasiado fácil de adivinar. Elija otra.",
  passwordNeedsMix: "Use mayúsculas, minúsculas, números y símbolos.",
  passwordTooShort: "Use al menos {{n}} caracteres.",
  samePassword: "Elija una contraseña que no haya usado antes.",
  emailRateLimited: "Acabamos de enviarle un correo. Espere un minuto antes de pedir otro.",
  rateLimited: "Demasiados intentos. Espere un minuto e inténtelo de nuevo.",
  alreadyRegistered: "Este correo ya tiene una cuenta. Toque Iniciar sesión, o ¿Olvidó su contraseña? si necesita una nueva.",
  emailNotConfirmed: "Confirme primero su correo. Abra el enlace que le enviamos e inicie sesión.",
  invalidCredentials: "El correo y la contraseña no coinciden. Revíselos e inténtelo de nuevo.",
  offline: "No tiene conexión. Compruébela e inténtelo de nuevo.",
  generic: "Algo salió mal. Inténtelo de nuevo.",
},
session: {
  signIn: "Iniciar sesión",
  renew: "Renovar sesión",
  expiredBody: "Toque Renovar sesión para seguir trabajando, o Iniciar sesión para empezar de nuevo.",
  expiredTitle: "Su sesión ha caducado",
},
appName: "AssetWRX",
social: {
  errorStartFailed: "No se pudo empezar a iniciar sesión. Inténtelo de nuevo.",
  errorPopupTimeout: "La ventana de inicio de sesión esperó demasiado y se cerró. Toca el botón de inicio de sesión para empezar de nuevo.",
  errorPopupBlocked: "Tu navegador bloqueó la ventana de inicio de sesión. Permite las ventanas emergentes en esta página y vuelve a tocar el botón de inicio de sesión.",
continueWith: "o continuar con",
google: "Continuar con Google",
apple: "Continuar con Apple",
microsoft: "Continuar con Microsoft",
signingIn: "Abriendo el inicio de sesión...",
errorSignInFailed: "No se completó el inicio de sesión. Inténtalo de nuevo.",
},
callback: {
  continueHere: "Continuar en este navegador",
  appSignInHint: "En la aplicación, toque Iniciar sesión y use el correo y la contraseña que acaba de elegir.",
title: "Iniciando sesión",
body: "Un momento.",
successTitle: "Ha iniciado sesión",
successBody: "Abriendo AssetWRX…",
errorTitle: "No se completó el inicio de sesión",
error: "Este enlace ha caducado o ya se usó. Toque Volver al inicio de sesión e inténtelo de nuevo.",
backToSignIn: "Volver al inicio de sesión",
openInApp: "Abrir la aplicación AssetWRX",
},
login: {
  biometricPasswordChanged: "Su contraseña ha cambiado, así que {{method}} está desactivado. Inicie sesión con su nueva contraseña y marque Usar {{method}} la próxima vez.",
  title: "Inicie sesión en AssetWRX",
showPassword: "Mostrar contraseña",
hidePassword: "Ocultar contraseña",
subtitle: "Inicie sesión en su cuenta",
email: "Correo electrónico",
password: "Contraseña",
emailPlaceholder: "usted@ejemplo.com",
passwordPlaceholder: "Su contraseña",
forgotPassword: "¿Olvidó su contraseña?",
signIn: "Iniciar sesión",
signingIn: "Iniciando sesión...",
noAccount: "¿No tiene cuenta?",
createAccount: "Crear cuenta",
createAccountCta: "¿Es nuevo? Cree una cuenta",
orWithEmail: "o inicia sesión con tu correo",
newHere: "¿Nuevo en AssetWRX?",
createAccountLink: "Crear una cuenta",
biometricUseNextTime: "Usar {{method}} la próxima vez",
biometricSignIn: "Iniciar sesión con {{method}}",
biometricPrompt: "Iniciar sesión en AssetWRX",
biometricMethodFace: "Face ID",
biometricMethodFingerprint: "la huella",
biometricMethodIris: "el iris",
biometricMethodGeneric: "la biometría",
embedSsoHint: "Este portal inicia su sesión con la cuenta de Microsoft de su organización.",
errorEmailRequired: "Introduzca su correo electrónico.",
errorEmailInvalid: "Introduzca un correo electrónico válido.",
errorPasswordRequired: "Introduzca su contraseña.",
errorLoginFailed: "No se pudo iniciar sesión. Revise su correo y su contraseña e inténtelo de nuevo.",
},
signup: {
  passwordHint: "Use al menos {{n}} caracteres.",
  useDifferentEmail: "Usar otro correo",
title: "Crear cuenta",
subtitle: "Únase a AssetWRX: el sistema operativo para sus activos físicos.",
firstName: "Nombre",
firstNamePlaceholder: "Juan",
lastName: "Apellido",
lastNamePlaceholder: "García",
role: "Rol",
rolePlaceholder: "Responsable de operaciones",
email: "Correo electrónico",
emailPlaceholder: "usted@ejemplo.com",
password: "Contraseña",
passwordPlaceholder: "Elija una contraseña segura",
showPassword: "Mostrar contraseña",
hidePassword: "Ocultar contraseña",
confirmPassword: "Confirmar contraseña",
confirmPlaceholder: "Vuelva a escribir la contraseña",
submit: "Crear cuenta",
signingUp: "Creando cuenta...",
hasAccount: "¿Ya tiene cuenta?",
signInLink: "Iniciar sesión",
emailInstead: "Registrarse con correo electrónico",
emailInsteadHide: "Ocultar el registro con correo electrónico",
useEmail: "Usar el correo electrónico",
useEmailHide: "Ocultar el registro por correo",
name: "Tu nombre",
namePlaceholder: "Alex García",
errorNameRequired: "Introduce tu nombre.",
hasAccountShort: "¿Ya tienes una cuenta?",
errorFirstNameRequired: "Introduzca su nombre.",
errorLastNameRequired: "Introduzca su apellido.",
errorRoleRequired: "Introduzca su rol.",
errorEmailRequired: "Introduzca su correo electrónico.",
errorPasswordRequired: "Introduzca una contraseña.",
errorPasswordMismatch: "Las contraseñas no coinciden.",
emailInvalid: "Introduce un correo electrónico válido.",
passwordsMatch: "Las contraseñas coinciden.",
passwordStrength: {
weak: "Débil",
fair: "Aceptable",
good: "Buena",
strong: "Fuerte",
},
errorSignUpFailed: "No se creó su cuenta. Inténtelo de nuevo.",
errorLanguageInvalid: "Elija un idioma admitido.",
errorTimezoneInvalid: "Elija una zona horaria válida.",
regionalSectionTitle: "Idioma, zona horaria y moneda",
regionalSectionBody: "Se aplican a su perfil y a su nuevo espacio de trabajo. Puede cambiarlos más tarde en la configuración.",
languageLabel: "Idioma",
timezoneLabel: "Zona horaria",
currencyLabel: "Moneda del espacio de trabajo",
currencyA11y: "Moneda del espacio de trabajo {{code}}",
successCheckEmail: "Cuenta creada. Revise su correo para confirmar la cuenta y luego inicie sesión.",
successEmailTitle: "Revisa tu bandeja de entrada",
successEmailBody: "Enviamos un enlace a {{email}}. Ábralo para terminar de crear su cuenta.",
resendConfirmation: "Enviar el enlace de nuevo",
resendingConfirmation: "Enviando…",
resendSuccess: "Enviado. Revise su bandeja de entrada y la carpeta de spam.",
resendError: "No se envió el enlace. Espere un minuto y toque Enviar el enlace de nuevo.",
consent: {
sectionTitle: "Antes de continuar",
sectionBody: "Revisa y acepta los documentos siguientes. Ambos son obligatorios para crear tu cuenta.",
acceptTerms: "He leído y acepto los <1>Términos del servicio</1>.",
acceptPrivacy: "He leído y acepto la <1>Política de privacidad</1>.",
errorTermsRequired: "Acepta las Condiciones del servicio para continuar.",
errorPrivacyRequired: "Acepta la Política de privacidad para continuar.",
a11yTermsCheckbox: "Aceptar las Condiciones del servicio",
a11yPrivacyCheckbox: "Aceptar la Política de privacidad",
compactLead: "Acepto:",
termsShort: "Términos",
read: "Leer",
privacyShort: "Privacidad",
a11yReadTerms: "Leer los Términos del servicio",
a11yReadPrivacy: "Leer la Política de privacidad",
shareUsage: "Compartir datos de uso para ayudar a mejorar AssetWRX (opcional)",
byContinuingBefore: "Al continuar aceptas los ",
byContinuingBetween: " y la ",
byContinuingAfter: ".",
termsDoc: "Términos del servicio",
privacyDoc: "Política de privacidad",
},
wizard: {
flowSubtitle: "Una configuración guiada rápida para tu espacio de trabajo",
valueStrip: "Empieza gratis. Sin tarjeta.",
stepProgress: "Paso {{current}} de {{total}}",
loadingDraft: "Restaurando tu progreso…",
welcomeBody: "Crea tu cuenta con Google, Apple, Microsoft o correo electrónico. Las cuentas nuevas pasan por una breve configuración tras iniciar sesión.",
continueWithEmail: "Continuar con correo electrónico",
back: "Atrás",
next: "Siguiente",
yes: "Sí",
no: "No",
errorUseCaseRequired: "Elige cómo piensas usar AssetWRX.",
errorWorkspaceNameRequired: "Introduce un nombre para el espacio de trabajo.",
errorStarterRequired: "Elige qué quieres hacer primero.",
useCaseTitle: "Caso de uso principal",
useCaseBody: "Elige la opción que mejor te describa. Puedes ajustarlo más adelante.",
useCases: {
field_inspections: "Inspeccionar lugares o equipos",
asset_register: "Llevar un registro de lo que gestionamos",
jobs_workorders: "Organizar reparaciones y trabajos",
team_collab: "Trabajar con mi equipo",
compliance_reporting: "Certificados y cumplimiento",
other: "Otra cosa",
},
workspaceTitle: "Tu espacio de trabajo",
workspaceBody: "Este es el espacio de tu organización en AssetWRX. Puedes cambiarle el nombre más adelante en los ajustes.",
workspaceNameLabel: "Nombre del espacio de trabajo",
workspaceNamePlaceholder: "p. ej. Instalaciones Acme",
inviteOnlyNote: "Unirse al equipo de otra persona es solo por invitación (usa el enlace de tu correo de invitación).",
intentCreateTeam: "Crear un equipo en este espacio de trabajo",
intentInviteMembers: "Invitar a miembros del equipo después de la configuración",
starterTitle: "¿Qué quieres hacer primero?",
starterBody: "Abriremos el área correspondiente después de que inicies sesión y termines la configuración.",
starters: {
home: "Abrir el panel de inicio",
asset: "Añadir un activo",
inspection: "Iniciar una inspección",
schedule: "Programar una inspección",
team: "Gestionar equipo e invitaciones",
},
reviewTitle: "Revisar y crear cuenta",
reviewName: "Nombre: {{name}}",
reviewEmail: "Correo electrónico: {{email}}",
reviewWorkspace: "Espacio de trabajo: {{name}}",
reviewTeam: "Crear un equipo: {{yes}}",
reviewInvites: "Invitar a miembros: {{yes}}",
reviewEditHint: "Este paso solo muestra un resumen. Para escribir un nombre, correo electrónico o contraseña distintos, usa el botón de abajo (o vuelve Atrás para recorrer los pasos anteriores).",
reviewEditCta: "Editar nombre, correo electrónico y contraseña",
},
},
firstRunSample: {
secondCheck: {
property: "¿Hay detectores de humo y funcionan?",
vehicle: "¿Luces y neumáticos en buen estado?",
equipment: "¿Protecciones y etiquetas de advertencia en su sitio?",
other: "¿Equipo de seguridad presente y en buen estado?",
},
quickLook: {
templateName: "Revisión rápida",
firstCheck: "¿Estado visual aceptable?",
},
useCases: {
field_inspections: {
assetName: "Bomba de circulación de ejemplo",
assetDescription: "Un ejemplo que puede quitar, para probar una inspección de campo.",
templateName: "Revisión del estado de la bomba",
firstCheck: "¿Carcasa y protecciones bien sujetas?",
secondCheck: "¿Hay fugas, ruidos o vibraciones?",
},
jobs_workorders: {
assetName: "Unidad de tratamiento de aire de ejemplo",
assetDescription: "Un ejemplo que puede quitar, para localizar trabajo de mantenimiento y pasárselo a quien lo hace.",
templateName: "Recorrido de mantenimiento",
firstCheck: "¿Accesos y puntos de aislamiento despejados?",
secondCheck: "¿Hace falta algún mantenimiento posterior?",
},
compliance_reporting: {
assetName: "Equipo contra incendios de ejemplo",
assetDescription: "Un ejemplo que puede quitar, para probar revisiones de cumplimiento basadas en evidencias.",
templateName: "Revisión de evidencias de cumplimiento",
firstCheck: "¿Identificación y estado confirmados?",
secondCheck: "¿Evidencias recogidas y vigentes?",
},
asset_register: {
assetName: "Vehículo de servicio de ejemplo",
assetDescription: "Un ejemplo que puede quitar, que muestra el registro de un activo operativo.",
templateName: "Revisión del estado del vehículo",
firstCheck: "¿Estado exterior aceptable?",
secondCheck: "¿Equipo de seguridad presente y en buen estado?",
},
other: {
assetName: "Equipo de ejemplo",
assetDescription: "Un ejemplo que puede quitar, para probar una inspección y el trabajo posterior.",
templateName: "Revisión operativa rápida",
},
},
},
postSignupOnboarding: {
industryTitle: "¿Qué gestiona?",
industryHint: "Añadimos listas de verificación listas para usar. Puedes cambiarlas después en Listas de control.",
industryChoices: {
property: "Inmuebles",
fleet: "Flota",
equipment: "Equipos",
facilities: "Instalaciones",
mixed: "Una mezcla, u otra cosa",
},
title: "Configura tu espacio de trabajo",
subtitle: "Un nombre, dos elecciones rápidas y listo.",
stepProgress: "Paso {{current}} de {{total}}",
workspaceTitle: "Nombre del espacio de trabajo",
workspacePlaceholder: "Nombre de tu organización o equipo",
workspaceHint: "Normalmente el nombre de tu empresa o equipo. Puedes cambiarlo después.",
useCaseTitle: "¿Para qué usarás AssetWRX?",
roleTitle: "Tu rol",
teamTitle: "Equipo e invitaciones",
starterTitle: "¿Dónde quieres empezar?",
finish: "Continuar",
finishing: "Preparando…",
deferNote: "Puedes cambiar el idioma, la moneda y el equipo después en Cuenta.",
errorWorkspaceRequired: "Introduzca un nombre de espacio de trabajo.",
errorUseCaseRequired: "Elija un caso de uso principal.",
errorRoleRequired: "Elija su rol.",
errorSave: "No se pudo guardar. Inténtelo de nuevo.",
inviteNote: "Podrás invitar a personas después de este paso.",
applyingTitle: "Aplicando sus opciones",
applyingBody: "Estamos preparando tu espacio de trabajo. Un momento.",
languageTitle: "Idioma",
localeLineTitle: "Moneda e idioma",
localeChange: "Cambiar",
localeDone: "Listo",
languageHint: "Elige tu idioma. Puedes cambiarlo después en Cuenta.",
currencyTitle: "Moneda",
currencyHint: "Elige la moneda con la que trabajas. Puedes cambiarla después en Cuenta.",
},
firstActionChooser: {
title: "¿Qué quieres hacer primero?",
framing: "Añade algo que gestionas o prueba una inspección de práctica con un ejemplo.",
framingTeam: "Invita a las personas con las que trabajas, añade algo que gestionas o prueba una inspección de práctica.",
asset: {
title: "Añadir mi primer activo",
subtitle: "Solo necesitas un nombre y un tipo. Añade más después.",
},
sample: {
title: "Probar una inspección de práctica",
subtitle: "Añadimos un activo de ejemplo para que veas cómo funciona una inspección. Quítalo cuando quieras.",
},
recommended: "Sugerido",
reassure: "Puedes quitar el ejemplo cuando quieras.",
sampleErrorFallback: "No se pudo preparar el ejemplo. Puedes añadir tu propio activo en su lugar.",
skip: "Ir a Inicio",
team: {
title: "Configura tu equipo",
subtitle: "Crea un equipo e invita a las personas con las que trabajas. Te mostramos cada paso.",
subtitleLocked: "Los equipos vienen con un plan superior. Toca para ver qué planes lo incluyen.",
},
},
forgot: {
  sentAgain: "Enviado de nuevo. Revise su bandeja de entrada y la carpeta de spam.",
  spamHint: "¿No lo recibió? Revise la carpeta de spam.",
  sendAgain: "Enviarlo de nuevo",
title: "¿Olvidó su contraseña?",
subtitleEmail: "Introduzca su correo y toque Enviar enlace. Le enviaremos un enlace para elegir una nueva contraseña.",
email: "Correo electrónico",
emailPlaceholder: "usted@ejemplo.com",
sendLink: "Enviar enlace",
sending: "Enviando...",
backToSignIn: "Volver al inicio de sesión",
sentTitle: "Revise su correo",
sentBody: "Si {{email}} tiene una cuenta, le enviamos un enlace para restablecer la contraseña. Ábralo y elija una nueva.",
errorEmailRequired: "Introduzca su correo electrónico.",
errorSendFailed: "No se envió el enlace. Espere un minuto e inténtelo de nuevo.",
},
reset: {
  subtitleDoneApp: "Su contraseña se ha cambiado. Toque Iniciar sesión y úsela.",
  sendNewLink: "Enviar un enlace nuevo",
  titleExpired: "Este enlace ha caducado",
title: "Establecer nueva contraseña",
titleDone: "Contraseña actualizada",
subtitle: "Elija una nueva contraseña para su cuenta.",
subtitleNoSession: "Los enlaces para restablecer sirven una sola vez y caducan en una hora. Toque Enviar un enlace nuevo y le enviaremos otro.",
subtitleForm: "Escriba su nueva contraseña dos veces y toque Actualizar contraseña.",
subtitleDone: "Su contraseña se ha cambiado. Vuelva a la aplicación AssetWRX e inicie sesión con ella.",
newPassword: "Nueva contraseña",
confirmNewPassword: "Confirmar nueva contraseña",
confirmPassword: "Confirmar contraseña",
passwordPlaceholder: "Elija una contraseña segura",
confirmPlaceholder: "Vuelva a escribir la contraseña",
submit: "Actualizar contraseña",
updating: "Actualizando...",
loading: "Cargando...",
success: "Contraseña actualizada. Ya puede iniciar sesión.",
goToSignIn: "Iniciar sesión",
backToSignIn: "Volver al inicio de sesión",
errorTooShort: "Su nueva contraseña es demasiado corta. Use al menos {{n}} caracteres.",
errorPasswordRequired: "Introduzca una nueva contraseña.",
errorMismatch: "Las contraseñas no coinciden.",
errorUpdateFailed: "No se pudo actualizar la contraseña.",
errorResetFailed: "Error al restablecer la contraseña.",
errorInvalidSession: "Este enlace no es válido o ha caducado. Solicite uno nuevo en la página de inicio de sesión.",
},
reconsent: {
  firstBody: "Lea los Términos del servicio y la Política de privacidad, marque las dos casillas y toque Aceptar y continuar.",
  firstTitle: "Acepte las condiciones para continuar",
errorMustAcceptBoth: "Ambos documentos deben ser aceptados para continuar.",
errorMustAcceptOne: "El documento debe ser aceptado para continuar.",
errorSessionExpired: "Su sesión ha caducado. Elija \"Rechazar y cerrar sesión\" y luego inicie sesión nuevamente para continuar.",
errorCouldNotRecord: "No se pudo registrar su aceptación. Compruebe su conexión y vuelva a intentarlo.",
unavailableTitle: "No se pudo verificar la aceptación guardada",
unavailableBody: "Conéctese e intente nuevamente para verificar si algún documento necesita su revisión. Su trabajo guardado permanece en este dispositivo.",
tryAgain: "Intentar de nuevo",
continueOffline: "Continuar sin conexión por ahora",
signOut: "Cerrar sesión",
needsConsentTitle: "Los términos actualizados requieren su aceptación",
needsConsentBody: "Hemos actualizado los documentos a continuación. Revise y acepte ambos para continuar usando AssetWRX. Si decide no aceptar, se cerrará su sesión; aún podrá solicitar la eliminación de la cuenta o exportar sus datos más tarde.",
needsConsentBodyOne: "Hemos actualizado el documento a continuación. Revíselo y acéptelo para continuar usando AssetWRX. Si decide no aceptar, se cerrará su sesión; aún podrá solicitar la eliminación de la cuenta o exportar sus datos más tarde.",
acceptTermsA11y: "Acepto los Términos de Servicio (v{{version}})",
acceptTermsLabel: "Acepto los Términos de servicio (v{{version}}).",
readTermsA11y: "Leer Términos de Servicio",
readTerms: "Leer Términos de Servicio",
acceptPrivacyA11y: "Acepto la Política de Privacidad (v{{version}})",
acceptPrivacyLabel: "Acepto la Política de Privacidad (v{{version}}).",
readPrivacyA11y: "Leer la Política de Privacidad",
readPrivacy: "Leer la Política de Privacidad",
recording: "Registrando",
recordingEllipsis: "Registrando…",
acceptAndContinue: "Aceptar y continuar",
declineAndSignOut: "Rechazar y cerrar sesión",
},
guidedHub: {
  groupRule: {
    title: "Inspeccionar todo un grupo de activos con un mismo calendario",
    subtitle: "Configura una regla de grupo, por ejemplo cada puerta cortafuegos cada mes.",
  },
  assistantActivity: {
    title: "Elige quién cambia cosas con el asistente",
    subtitle: "Activa o desactiva los cambios con el asistente para los miembros.",
  },
  requestFeature: {
    title: "Solicitar una función",
    subtitle: "Cuéntale al equipo de AssetWRX qué debería hacer la app a continuación.",
  },
  assetToursHint: "Hay más guías en cada activo: ábrelo, toca + y luego Guíame.",
  guide: {
    subtitle: "Ayuda paso a paso para cada parte de la aplicación.",
    title: "Leer la guía",
  },
  invite: {
    subtitle: "Reciben un correo y se unen a tu equipo.",
    title: "Invitar a un compañero",
  },
title: "¿Qué quieres hacer?",
subtitle: "Elige una tarea. Resaltamos cada cosa que tocar, paso a paso.",
close: "Cerrar",
groups: {
setup: "Configura tu espacio de trabajo",
reactive: "Compartir",
proactive: "Planificar el trabajo",
workspace: "Gestionar tu espacio",
},
building: {
title: "Configurar un edificio",
subtitle: "Un edificio y luego sus plantas y salas.",
},
asset: {
title: "Añadir un activo",
subtitle: "Un edificio, vehículo, máquina o cualquier cosa que gestiones.",
},
site: {
title: "Añadir un sitio",
subtitle: "Un lugar, como un edificio o almacén, que agrupa activos.",
},
contractor: {
title: "Añadir un contratista",
subtitle: "Una persona o empresa a la que envías trabajo.",
},
team: {
title: "Crear un equipo",
subtitle: "Comparte activos y trabajo con tus compañeros.",
},
requesters: {
title: "Compartir un activo",
subtitle: "Deja que alguien vea un activo o pida trabajo sobre él.",
},
inspection: {
title: "Programar una inspección",
subtitle: "Una visita, o una que se repite.",
},
job: {
title: "Crear una orden de trabajo",
subtitle: "Una reparación o tarea, y quién la hace.",
},
maintenancePlan: {
title: "Configurar un plan de mantenimiento",
subtitle: "Trabajo que se repite, como un mantenimiento anual.",
},
compliance: {
title: "Revisar certificados y cumplimiento",
subtitle: "Ve qué falta o vence, y resuélvelo.",
},
industryPack: {
title: "Añadir listas de verificación ya preparadas",
subtitle: "Listas hechas para tu sector.",
},
transferOwnership: {
title: "Ceder el equipo a un nuevo propietario",
subtitle: "Nada cambia hasta que acepte la oferta.",
},
},
guidedJourney: {
  esg: {
    figures: {
      title: "Las cifras principales",
      body: "Cada cifra de los últimos 12 meses con su cambio frente al año anterior, a partir de las lecturas que ya registra. Debajo, el gráfico y de dónde viene el carbono.",
    },
    refrigerant: {
      title: "Refrigerante y gases fluorados",
      body: "El gas sale de los detalles del activo. Registre la carga; la aplicación calcula las toneladas de CO2e, cada cuánto necesita un control de fugas y lo programa. El registro de fugas lista cada control, fuga y recarga.",
    },
    certificates: {
      title: "Certificados energéticos",
      body: "Los certificados se guardan una sola vez, en Documentos. Añada allí el EPC o el DEC y la IA lee la calificación y las fechas; esta tarjeta lo muestra con Abrir certificado y Editar.",
    },
    writeup: {
      title: "Redáctalo",
      body: "Elige el lector y la IA escribe un breve resumen que solo usa estas cifras, con botones para crear el trabajo que sugiere.",
      },
    },
  subJobs: {
    card: {
      title: "Las partes de este trabajo",
      body: "Cada subtrabajo tiene su propia persona o contratista, fecha, comprobaciones y fotos. Usted revisa cada uno; el trabajo completo se aprueba una vez.",
    },
    add: {
      title: "Toque Añadir subtrabajo",
      body: "La primera vez, diga quién dirige el trabajo. Luego dé a la parte un título, quién la hace y cuándo. Añada varias seguidas con Añadir y siguiente.",
    },
  },
  visits: {
    add: {
      title: "Planificar otra visita",
      body: "Elija el día y la hora. El trabajo aparece en Trabajo y en el calendario cada día de visita, y se completa una sola vez, al final.",
    },
  },
  groupRule: {
    add: {
      title: "Toca Añadir regla de grupo",
      body: "Una regla de grupo pone una lista de verificación en cada activo de un grupo, con un mismo calendario.",
    },
    which: {
      title: "Indica qué activos",
      body: "Elige una clase: Lugar, Equipo, Vehículo u Otro. Luego limítala a un tipo de lugar o a uno de tus tipos de activo, como Puerta cortafuegos.",
    },
    where: {
      title: "Indica dónde",
      body: "Déjalo en En cualquier lugar, o elige un lugar como el Edificio A para tomar solo lo que hay dentro. Una zona lo limita aún más.",
    },
    checklist: {
      title: "Elige la lista de verificación",
      body: "Cada inspección que crea la regla usa esta lista de verificación.",
    },
    howOften: {
      title: "Frecuencia y desde cuándo",
      body: "Elige la frecuencia y la fecha de la primera inspección. La siguiente de cada activo se planifica cuando se termina la anterior.",
    },
    summary: {
      title: "Revisa la frase",
      body: "La regla se resume en una frase, con cuántas inspecciones crea al guardar.",
    },
    save: {
      title: "Guarda la regla",
      body: "Toca Guardar regla. Las inspecciones aparecen en la página Trabajo, y los activos que se sumen al grupo después reciben la suya.",
    },
  },
  assistantActivity: {
    policy: {
      title: "Elige quién puede hacer cambios",
      body: "Propietarios y administradores eligen: todos, solo administradores o nadie. Con nadie, el asistente responde y aconseja, pero no cambia nada.",
    },
    briefing: {
      title: "Tu resumen semanal",
      body: "Activa o desactiva el resumen semanal arriba del asistente y vuelve a activar las preguntas sugeridas. Es tu propio ajuste.",
    },
    memory: {
      title: "Lo que recuerda el asistente",
      body: "Preferencias para todo el espacio de trabajo que el asistente sigue, como cómo llamáis a las cosas o quién suele recibir un tipo de trabajo. Añádelas, cámbialas u olvídalas aquí.",
    },
    list: {
      title: "Aquí aparece cada cambio",
      body: "Qué se cambió, quién y cuándo, y si se deshizo. Los miembros ven los suyos.",
    },
  },
  requestFeature: {
    open: {
      title: "Toca Solicitar una función",
      body: "Está en Ayuda, debajo de la Guía del usuario.",
    },
    what: {
      title: "Di qué te gustaría",
      body: "Un título corto y luego cómo te ayudaría. No incluyas datos personales ni de clientes.",
    },
    area: {
      title: "Elige la parte de la app",
      body: "Indica de qué trata y cuánto importa, y añade capturas si ayudan.",
    },
    send: {
      title: "Envíala",
      body: "Toca Enviar solicitud. Llega al equipo de AssetWRX y en Tus solicitudes verás su estado y las respuestas.",
    },
  },
  inMoreMenu: "Toca Más para encontrarlo.",
  myDay: {
    startNext: {
      body: "Toca Empezar siguiente para abrir el trabajo y comenzarlo.",
      title: "Empieza la siguiente visita",
    },
    share: {
      body: "Toca Compartir ubicación para que tu planificador vea si vas con retraso. O toca Siguiente.",
      title: "Compartir tu ubicación (opcional)",
    },
    agenda: {
      body: "Tus visitas de hoy, en orden, con el trayecto entre ellas. Toca Siguiente.",
      title: "Este es tu día",
    },
  },
  inPlusMenu: "Toca + para encontrarlo.",
next: "Siguiente",
skipStep: "Saltar este paso",
skip: "Terminar guía",
share: {
  confirm: {
    body: "Elige Puede ver o Puede pedir trabajo y toca Compartir. Quien no tenga cuenta recibe una invitación.",
    title: "Elige qué pueden hacer",
  },
assetOpen: {
title: "Abre el activo",
body: "Toca el activo que quieres compartir.",
},
shareAction: {
title: "Compartir con una persona",
body: "Toca Compartir con una persona o equipo. Solo tendrán acceso a este activo.",
},
createContact: {
title: "Elige a la persona",
body: "Toca un contacto, o Crear y vincular contacto para añadir a alguien. Luego toca Continuar.",
},
},
inspection: {
pickAsset: {
title: "Elige el activo",
body: "Toca el activo que quieres inspeccionar.",
},
createChecklist: {
title: "Elige la lista",
body: "Mantén esta lista y toca Siguiente, o toca Cambiar y elige otra. ¿No hay ninguna? Toca Crear una lista.",
},
when: {
title: "Elige cuándo",
body: "Toca Ahora para empezar ya, o Más tarde para elegir fecha y hora.",
},
submit: {
title: "Empieza",
body: "Toca Iniciar inspección (o Programar si elegiste Más tarde). Responde cada punto y toca Completar inspección.",
},
},
job: {
pickAsset: {
title: "Elige el activo",
body: "Toca el activo al que corresponde el trabajo.",
},
title: {
title: "Di qué hay que hacer",
body: "Escribe un título corto, como Cambiar la correa, y elige quién lo hace.",
},
submit: {
title: "Crea la orden de trabajo",
body: "Toca Crear orden de trabajo (o Programar si elegiste Más tarde). La persona asignada recibe un aviso y debe aceptar.",
},
},
proactive: {
when: {
title: "Toca Más tarde",
body: "Luego elige el día y la hora de la primera revisión.",
},
recurrence: {
title: "Elige cada cuánto",
body: "En Repetir, toca cada cuánto vuelve, como Cada mes.",
},
submit: {
title: "Prográmalo",
body: "Toca Programar inspección. Cada revisión aparece en Trabajo en su día; toca Abrir en el mensaje.",
},
},
addSite: {
name: {
title: "Pon nombre al sitio",
body: "Escribe el nombre que usa tu equipo, como Almacén Norte.",
},
location: {
title: "Dirección (opcional)",
body: "Escribe la dirección y elígela de la lista. O toca Siguiente para saltar.",
},
classify: {
title: "Tipo de sitio (opcional)",
body: "Elige qué tipo de lugar es y su estado. O toca Siguiente para saltar.",
},
structure: {
title: "Sitio principal y equipo (opcional)",
body: "Ponlo dentro de un sitio mayor o elige el equipo responsable. O toca Siguiente.",
},
create: {
title: "Crea el sitio",
body: "Toca Crear sitio. El sitio se abre, listo para sus activos.",
},
},
addAssetsToSite: {
assign: {
title: "Añade activos a este sitio",
body: "Toca Asignar y elige el activo que mover aquí. Un mensaje confirma el cambio.",
},
},
addContractor: {
name: {
title: "Escribe su nombre",
body: "Escribe el nombre de la persona o empresa.",
},
contact: {
title: "Escribe su correo",
body: "Un contratista necesita un correo: ahí le llegan las invitaciones a órdenes de trabajo y a presupuestos.",
},
save: {
title: "Añádelos",
body: "Toca Añadir contacto. Para darles trabajo, abre una orden de trabajo y toca Asignar.",
},
},
raiseRequest: {
  summary: {
    body: "Escribe un resumen corto, como Grifo que gotea en la cocina.",
    title: "Di qué pasa",
  },
outcome: {
title: "¿Qué necesitas?",
body: "Elige: Solo ayuda, Un trabajo o Una inspección.",
},
submit: {
title: "Envíalo",
body: "Toca Enviar. Una orden de trabajo o una inspección se abre ya rellena; si no, espera en Trabajo.",
},
},
shareReport: {
contact: {
title: "Elige quién lo recibe",
body: "Toca Seleccionar contacto y elige a la persona.",
},
role: {
title: "Comprueba quién es",
body: "Su relación viene del contacto. Toca Cambiar solo si está mal, o Siguiente.",
},
send: {
title: "Envíalo",
body: "Toca Enviar informe. Reciben un correo con un enlace y se te avisa cuando respondan.",
},
},
planADay: {
  apply: {
    body: "Nada se guarda hasta que toques Aplicar. Después, se pide a cada persona que acepte su día.",
    title: "Toca Aplicar para guardar",
  },
  optimise: {
    body: "Toca Sugerir un plan para llenar el día con el menor desplazamiento. Toca × en lo que no quieras.",
    title: "O deja que la app sugiera",
  },
  panel: {
    body: "Elige la persona, el día y la hora. Se ve punteado hasta que toques Aplicar.",
    title: "Elige quién y cuándo",
  },
  unplanned: {
    body: "Esta lista muestra trabajo sin hora o sin persona. Toca uno para planificarlo.",
    title: "Empieza por Sin planificar",
  },
  },
convertRequest: {
approve: {
title: "Aprueba la solicitud",
body: "Toca Aprobar y de nuevo Aprobar para confirmar. Se avisa a quien lo pidió.",
},
convert: {
title: "Conviértela en trabajo",
body: "Toca Crear un trabajo o Inspeccionar. Los datos ya están; tú eliges quién y cuándo.",
},
},
addDocument: {
  title: {
    body: "Escribe un nombre claro, como Certificado de gas 2026.",
    title: "Ponle un título",
  },
type: {
title: "Elige el tipo de documento",
body: "En Tipo de documento, elige Certificado, Garantía, Cumplimiento o General.",
},
save: {
title: "Añade el archivo y guarda",
body: "Adjunta el archivo, añade la fecha de caducidad si la tiene y toca Guardar documento.",
},
},
assignAssetTeam: {
change: {
title: "Toca Cambiar",
body: "Junto a Equipo responsable, toca Cambiar.",
},
pick: {
title: "Elige el equipo",
body: "Toca el equipo. Un mensaje confirma quién puede verlo ahora.",
},
},
addTeam: {
open: {
title: "Toca Crear equipo",
body: "Un equipo comparte activos y trabajo con quienes invites. ¿Ya tienes uno? Toca Nuevo equipo.",
},
name: {
title: "Pon nombre al equipo",
body: "Usa un nombre que tus compañeros reconozcan.",
},
submit: {
title: "Créalo",
body: "Toca Crear equipo. Después se abre la invitación para añadir personas.",
},
},
inviteMembers: {
open: {
title: "Toca Invitar personas",
body: "Invita a un compañero a este equipo.",
},
email: {
title: "Escribe su correo",
body: "Escribe su correo, uno por línea, y elige Miembro o Admin.",
},
send: {
title: "Envía la invitación",
body: "Toca Enviar invitación. Recibirá un correo y aparecerá en Miembros al aceptar.",
},
},
assignContractor: {
open: {
title: "Toca Asignar",
body: "Elige al compañero o contratista. Un contratista necesita correo para recibir el aviso.",
},
},
aiReport: {
reader: {
title: "¿Para quién es?",
body: "Elige el lector. Los mismos hechos se cuentan en el orden que le importa a ese lector. O toca Siguiente.",
},
analyses: {
title: "Elige qué incluir",
body: "Todos los temas están activos. Toca uno para quitarlo, o toca Siguiente.",
},
generate: {
title: "Crea el informe",
body: "Revisa el coste y toca Redactar la versión con IA. Te avisamos cuando esté listo, y los créditos se usan solo entonces.",
},
},
relateAsset: {
search: {
title: "Busca el otro activo",
body: "Busca el otro activo y tócalo.",
},
save: {
title: "Guarda el vínculo",
body: "Elige cómo se relacionan y toca Añadir relación.",
},
},
publicIntake: {
share: {
title: "Toca Compartir",
body: "El aviso por código QR se configura desde Compartir.",
},
choose: {
title: "Dejar que cualquiera avise",
body: "Toca Dejar que cualquiera con el código avise de un problema. No hace falta cuenta.",
},
enable: {
title: "Actívalo",
body: "Activa el interruptor. El código y el enlace aparecen debajo.",
},
copy: {
title: "Comparte el enlace",
body: "Toca Copiar enlace (o Imprimir QR en un ordenador) y ponlo a la vista.",
},
},
setUpBuilding: {
name: {
title: "Pon nombre al edificio",
body: "Escribe el nombre que usa la gente, como Edificio A o Torre Norte.",
},
type: {
title: "Es un lugar",
body: "Lugar ya está elegido. Las plantas, salas, aparcamientos y otras zonas también son lugares.",
},
placeType: {
title: "Toca Edificio",
body: "Indica qué tipo de lugar es. Elige Edificio aquí; después eliges Planta o Sala para lo que va dentro.",
},
save: {
title: "Créalo",
body: "Toca Crear activo. Después se abre el edificio.",
},
addInside: {
title: "Añade sus plantas",
body: "Toca Añadir lugar dentro para añadir la Planta 1. Cada planta tiene el mismo botón para sus salas, y Añadir equipo aquí para lo que tiene instalado.",
},
},
addAsset: {
name: {
title: "Ponle nombre",
body: "Escribe el nombre que usa tu equipo, como Caldera 3 o Calle Roble 14.",
},
type: {
title: "Elige el tipo",
body: "Toca Lugar, Equipo, Vehículo u Otro. Un lugar es un edificio, una planta, una sala o cualquier otra zona. Si aparece «Parece», toca Usar esto.",
},
location: {
title: "¿Dónde está? (opcional)",
body: "Añade el sitio o la dirección para encontrarlo. O toca Siguiente para saltar.",
},
identify: {
title: "Foto y número (opcional)",
body: "Añade una foto y el número de su placa para encontrarlo en el sitio. O toca Siguiente.",
},
details: {
title: "Más detalles (opcional)",
body: "Añade marca, modelo y fechas clave ahora o después. O toca Siguiente.",
},
save: {
title: "Créalo",
body: "Toca Crear activo. Se abre a continuación, listo para inspeccionar.",
},
},
decommission: {
options: {
title: "Abre el menú ⋯",
body: "Toca ⋯ en la parte superior del activo.",
},
status: {
  title: "Toca Cambiar estado",
  body: "Aquí están poner en servicio, poner fuera de servicio, retirar y restaurar.",
},
choose: {
title: "Toca Poner fuera de servicio",
body: "El activo conserva su historial. El trabajo rutinario se detiene hasta que vuelva al servicio.",
},
reason: {
title: "Elige un motivo",
body: "Elige por qué sale de servicio. Queda guardado en el registro.",
},
confirm: {
title: "Confirma",
body: "Toca Generar la orden de trabajo de puesta en seguridad para dejarlo seguro primero, o desactiva esa opción y toca Poner fuera de servicio ahora.",
},
},
commission: {
start: {
title: "Toca Poner en servicio",
body: "En el aviso, toca Poner en servicio.",
},
inspect: {
title: "Inicia la inspección",
body: "Toca Iniciar inspección. Cuando termine junto con sus trabajos, toca Volver al servicio.",
},
},
retire: {
options: {
title: "Abre el menú ⋯",
body: "Toca ⋯ en la parte superior del activo.",
},
status: {
  title: "Toca Cambiar estado",
  body: "Aquí están poner en servicio, poner fuera de servicio, retirar y restaurar.",
},
choose: {
title: "Toca Retirar definitivamente el activo",
body: "Solo se puede retirar definitivamente un activo fuera de servicio. Si no lo está, se te ofrece primero ponerlo fuera de servicio.",
},
reason: {
title: "Indica por qué",
body: "Elige el motivo. Si se vendió o desechó, indica a quién.",
},
confirm: {
title: "Escribe RETIRAR para confirmar",
body: "Escribe RETIRAR y toca Retirar definitivamente este activo. Un propietario o admin puede recuperarlo.",
},
},
meterReading: {
value: {
title: "Escribe la lectura",
body: "Escribe el número del contador. En el móvil puedes añadir una foto y la app lo lee.",
},
save: {
title: "Guárdala",
body: "Toca Guardar lectura. Los planes por kilómetros u horas parten de este número.",
},
},
maintenancePlan: {
  asset: {
    body: "Toca Activo y elige para qué es el plan. ¿Ya está? Toca Siguiente.",
    title: "Elige el activo",
  },
title: {
title: "Di qué se hace",
body: "En Qué se hace, escribe el trabajo, como Revisión anual.",
},
cadence: {
title: "Elige cada cuánto",
body: "En ¿Cuándo toca?, deja Se repite y pon Cada 12 meses, o activa Repetir por contador. Luego Siguiente.",
},
save: {
title: "Crea el plan",
body: "Elige Orden de trabajo o Inspección en Hacerlo como y toca Crear plan. Un mensaje dice cuándo aparece la primera en Trabajo.",
},
},
addKnowledge: {
kind: {
title: "Elige qué añadir",
body: "Elige una nota, preguntas frecuentes, instrucciones, enlace o archivo.",
},
title: {
title: "Ponle un título",
body: "Usa palabras que la gente buscaría, como Reiniciar caldera. Luego escríbelo o díctalo.",
},
save: {
title: "Guárdalo",
body: "Toca Guardar. Cualquiera que trabaje en este activo lo encontrará.",
},
},
moveAsset: {
reason: {
title: "¿Se movió o es una corrección?",
body: "Toca Se movió o Estaba mal.",
},
location: {
title: "¿Dónde está ahora?",
body: "Busca la dirección o usa tu ubicación actual.",
},
submit: {
title: "Guarda el cambio",
body: "Toca Registrar el traslado o Corregir la ubicación. El lugar anterior queda en el historial.",
},
},
complianceRegister: {
refine: {
title: "Busca lo que necesitas (opcional)",
body: "Busca por nombre o toca Refinar para filtrar. Luego toca Siguiente.",
},
row: {
title: "Resuelve una fila",
body: "Cada fila dice qué falta o vence. Toca su botón, como Renovar.",
},
},
industryPack: {
install: {
title: "Instala un paquete",
body: "Toca Instalar paquete en el de tu sector. Sus listas aparecen en Listas de control.",
},
},
transferOwnership: {
open: {
title: "Toca Transferir propiedad",
body: "Está en Ajustes del equipo. Solo lo ve el propietario, cuando hay otro miembro.",
},
member: {
title: "Elige el nuevo propietario",
body: "Elige un miembro. Nada cambia hasta que acepte; entonces pasas a ser admin.",
},
},
},
mfa: {
  codeNotValid: "Ese código no funcionó. Los códigos cambian cada 30 segundos: abra su aplicación de autenticación y escriba el más reciente.",
invalidCode: "Ese código no es válido. Comprueba tu aplicación de autenticación e inténtalo de nuevo.",
enterCode: "Introduce el código de 6 dígitos",
verifying: "Verificando…",
verifyCta: "Verificar y activar",
challenge: {
  contactSupport: "Contactar con el soporte de AssetWRX",
pageTitle: "Verificación en dos pasos",
title: "Introduce tu código de verificación",
body: "Abre tu aplicación de autenticación e introduce el código de 6 dígitos de AssetWRX.",
backA11y: "Cancelar el inicio de sesión y volver",
back: "Atrás",
loadError: "No se pudo cargar tu método de verificación en dos pasos. Inicia sesión de nuevo.",
resetSent_one: "Hemos avisado al administrador de tu espacio de trabajo. Puede restablecer tu verificación en dos pasos para que la configures de nuevo.",
resetSent_other: "Hemos avisado a los administradores de tu espacio de trabajo. Pueden restablecer tu verificación en dos pasos para que la configures de nuevo.",
resetNoAdmin: "Eres el propietario del espacio de trabajo, así que nadie por encima de ti puede restablecerlo. Inicia sesión en un dispositivo que todavía tenga tu app de autenticación o contacta con el soporte de AssetWRX más abajo.",
resetError: "No se pudo enviar la solicitud. Inténtalo de nuevo.",
verifyCta: "Verificar",
lostDevice: "¿Has perdido el dispositivo? Pide a un administrador del espacio de trabajo que restablezca tu verificación en dos pasos, o cierra sesión.",
requestReset: "Solicitar un restablecimiento a tu administrador",
requesting: "Enviando…",
signOut: "Cerrar sesión",
resetSent_many: "Hemos avisado a los administradores de tu espacio de trabajo. Pueden restablecer tu verificación en dos pasos para que la configures de nuevo.",
},
enroll: {
  otherPhoneQr: "¿Usa otro teléfono? Escanee este código.",
  step2SameDevice: "Toque Abrir la aplicación de autenticación, añada la cuenta y vuelva aquí",
  a11yGooglePlay: "{{app}}: descargar en Google Play",
  a11yAppStore: "{{app}}: descargar en la App Store",
  appBlurb: "Gratis. Funciona en iPhone y Android.",
backA11y: "Volver",
back: "Atrás",
title: "Configurar el inicio de sesión en dos pasos",
lead: "Añade un segundo paso al iniciar sesión para que solo tú puedas entrar — incluso si alguien conoce tu contraseña. Tarda alrededor de un minuto.",
startError: "No se pudo iniciar la configuración. Inténtalo de nuevo.",
step1: "Instala una aplicación de autenticación gratuita en tu teléfono",
step1Hint: "¿Ya tienes una? Pasa al paso 2.",
appStore: "iPhone",
googlePlay: "Android",
step2: "En la aplicación, toca «＋» y escanea este código",
qrAlt: "Código QR de verificación en dos pasos",
manualLabel: "¿No puedes escanear? Introduce esta clave manualmente:",
copySecret: "Copiar clave de configuración",
openApp: "Abrir la aplicación de autenticación",
step3: "Introduce el código de 6 dígitos que muestra la aplicación",
preparing: "Preparando tu configuración…",
backupTitle: "Añade una copia de seguridad, por si acaso",
backupBody: "La verificación en dos pasos está activada. Si alguna vez pierdes tu aplicación de autenticación, una segunda en otro dispositivo es la forma más rápida de volver a entrar. Recomendado.",
addBackup: "Agregar un autenticador de respaldo",
finish: "Finalizar",
backupSetupTitle: "Añade tu aplicación de autenticación de respaldo",
backupSetupBody: "Escanea esto con tu segunda aplicación de autenticación y luego introduce el código de 6 dígitos que muestra.",
skipBackup: "Omitir por ahora",
},
gate: {
challengeTitle: "Confirma que eres tú",
blockedTitle: "El inicio de sesión en dos pasos es obligatorio",
nagTitle: "Activa el inicio de sesión en dos pasos",
challengeBody: "Introduce el código de tu aplicación de autenticación para continuar.",
blockedBody: "Para proteger tu cuenta, configura una aplicación de autenticación para continuar.",
nagBody: "Añade una aplicación de autenticación para reforzar mucho la seguridad — solo tarda un minuto.",
nagBodyDated: "El inicio de sesión en dos pasos será obligatorio a partir del {{dateLabel}}. Configúralo ahora — solo tarda un minuto.",
verifyCta: "Introducir código",
setupCta: "Configurar la verificación en dos pasos",
signOut: "Cerrar sesión",
later: "Recordármelo más tarde",
},
},
};
